import { HttpErrorResponse } from '@angular/common/http'
import { Action, createAction, props } from '@ngrx/store'
import { SetupIntent, StripeError } from '@stripe/stripe-js'
import { GbPaymentIntent } from 'libs/gb-front/payment/util/src/lib/gb-payment.models'

export const submitSetupIntent = createAction(
  '[Stripe/API] Submit SetupIntent',
  props<{ initStripeElements?: boolean }>(),
)

export const submitSetupIntentSuccess = createAction(
  '[Stripe/API] SetupIntent Success',
  props<{ setupIntent: SetupIntent; initStripeElements?: boolean }>(),
)

export const clearSetupIntent = createAction('[Stripe/API] Clear SetupIntent')

export const submitSetupIntentError = createAction(
  '[Stripe/API] Setup Intent Error',
  props<{ error: HttpErrorResponse }>(),
)

export const initStripeElements = createAction('[Stripe] Init Stripe Elements', props<{ isSetupIntent?: boolean }>())

export const confirmCardSetup = createAction('[Stripe/API] Confirm Card Setup', props<{ onSuccess?: () => Action }>())

export const attachPaymentMethod = createAction(
  '[Stripe/API] Attach Payment Method',
  props<{ paymentMethodId: string; onSuccess?: () => Action }>(),
)

export const attachPaymentMethodSuccess = createAction(
  '[Stripe/API] Attach Payment Method Success',
  props<{ paymentMethodId: string; onSuccess?: () => Action }>(),
)

export const attachPaymentMethodFailure = createAction(
  '[Stripe/API] Attach Payment Method Failure',
  props<{ error?: StripeError }>(),
)

export const detachPaymentMethod = createAction(
  '[Stripe/API] Detach Payment Method',
  props<{
    paymentMethodId: string
    isSystemInitiated?: boolean // triggered after payment when user opted to not save card
    onComplete?: () => Action
  }>(),
)

export const detachPaymentMethodSuccess = createAction(
  '[Stripe/API] Detach Payment Method Success',
  props<{
    isSystemInitiated?: boolean // triggered after payment when user opted to not save card
    onComplete?: () => Action
  }>(),
)

export const detachPaymentMethodFailure = createAction(
  '[Stripe/API] Detach Payment Method Failure',
  props<{ onComplete?: () => Action }>(),
)

export const createPreAuthPaymentIntent = createAction(
  '[SelectedItem/API] Create Pre-Auth Payment Intent',
  props<{ onSuccess?: () => Action }>(),
)

export const createPreAuthPaymentIntentSuccess = createAction(
  '[SelectedItem/API] Create Pre-Auth Payment Intent Success',
  props<{ payment: GbPaymentIntent; onSuccess?: () => Action }>(),
)

export const createPreAuthPaymentIntentFailure = createAction(
  '[SelectedItem/API] Create Pre-Auth Payment Intent Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const handlePaymentCompletion = createAction(
  '[Stripe/API] Handle Payment Completion',
  props<{ paymentMethodId: string; isDigitalWallet: boolean; isPreAuth?: boolean }>(),
)

export const onPaymentSuccess = createAction('[Stripe/API] On Payment Success')

export const cancelPayment = createAction('[Stripe/API] Cancel Payment')

export const cancelPaymentSuccess = createAction('[Stripe/API] Cancel Payment Success')

export const cancelPaymentFailure = createAction(
  '[Stripe/API] Cancel Payment Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const cancelPaymentIntent = createAction('[Stripe/API] Cancel Payment Intent')

export const cancelPaymentIntentSuccess = createAction('[Stripe/API] Cancel Payment Intent Success')

export const cancelPaymentIntentFailure = createAction(
  '[Stripe/API] Cancel Payment Intent Failure',
  props<{ error: HttpErrorResponse }>(),
)
